/**
 * i18n — français (langue source) + anglais.
 * Clés plates par domaine. Langue persistée en localStorage ('nxc_lang').
 */
import i18next, { type i18n as I18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { fr } from './fr';
import { en } from './en';

const STORAGE_KEY = 'nxc_lang';

export type AppLanguage = 'fr' | 'en';

export const LANGUAGES: { code: AppLanguage; label: string }[] = [
  { code: 'fr', label: 'Français (FR)' },
  { code: 'en', label: 'English (EN)' },
];

function initialLanguage(): AppLanguage {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'fr') return stored;
  } catch {
    /* localStorage indisponible (SSR / tests) */
  }
  return 'fr';
}

export function persistLanguage(lng: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* ignoré */
  }
}

void i18next.use(initReactI18next).init({
  lng: initialLanguage(),
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  resources: { fr: { translation: fr }, en: { translation: en } },
});

export const i18n: I18n = i18next;
export type { TranslationKey } from './fr';
